form(data-hook="search-form").pure-form.search-bar
  .input-addon
    i.icon.ion-ios-search-strong.input-addon-item
    input(type="text", placeholder=placeholder || "Produktname").search.input-addon-field
    .input-addon-item.reset-search(data-hook="reset-search")
      a(href="#", role="button", class=model && model.q ? null : 'hidden'): i.icon.ion-close
